import { render, staticRenderFns } from "./StorePsiDetail.vue?vue&type=template&id=00076d53&scoped=true"
import script from "./StorePsiDetail.vue?vue&type=script&lang=js"
export * from "./StorePsiDetail.vue?vue&type=script&lang=js"
import style0 from "./StorePsiDetail.vue?vue&type=style&index=0&id=00076d53&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00076d53",
  null
  
)

export default component.exports